<ng-container *ngIf="screenName != 'invite-job-listing'">

  <app-jobs-candidates-slide-filter [valuesSentForFilters]="entitySent"
    (valuesRetainedForFilters)="onFilterToggle($event)">
    <app-job-filter-vertical-template *ngIf="panel == 'jobs' " [businessId]="businessId" [filterChanges]="filterChanges"
      [jobFilterData]="filterConfig"> </app-job-filter-vertical-template>
    <app-job-applicant-filter
      *ngIf="panel === 'job applicants' && showApplicantFilter==true"></app-job-applicant-filter>
    <app-candidate-invited-for-job-filter
      *ngIf="panel === 'candidates invited'  && showApplicantFilter==true"></app-candidate-invited-for-job-filter>
  </app-jobs-candidates-slide-filter>

  <!-- `[class.pointer-events-none]` used to sit on this <ng-container>, which
       renders no DOM node — so the binding never applied and the Job page had
       NO guard behind the open All Filters panel (the Candidate page's working
       equivalent is on its real #entity-container div). Moved onto the two real
       elements the container wrapped, so a stray or rapid click landing outside
       the panel can't reach the header controls or a job row underneath and
       navigate somewhere unexpected. -->
  <ng-container>
    <header [class.pointer-events-none]="isFilterOpen">
      <div class="hpanel" data-gs-cards="native">
        <div class="panel-body filter-hdr-pad shdwcon brad-0">
          <div class="job-candidate-container pad-lt-0">
            <div class="row">
              <div class="dropdown-filters-container mr-rt-lt-0 form-group">
                <div class="gs-search-box gs-search-box--filter mr-lt-16">
                  <span class="job-search-svg-icon">
                    <ng-icon name="tablerSearch"></ng-icon>
                  </span>
                  <input #Search placeholder="Search Job Title, Job ID, Skills" type="text" [(ngModel)]="searchContent"
                   [ngModelOptions]="{standalone: true}" (input)="searchfilter(Search.value)" class="input-sm form-control job-cand-searchBox" />
                </div>
                <div class="job-cand-dropdown-filter-elements-container">
                  <app-job-filter-template [businessId]="businessId" (panelValue)="getPanelValue($event)" [loading]="loadSkeleton | async"
                    (valuesRetainedForFilters)="onFilterToggle($event)" [jobFilterData]="filterConfig"
                    [filterChanges]="tempFilterChanges"></app-job-filter-template>
                </div>
                <div class="all-filter-container">
                  <div class="all-filters" (click)="openFilterSlider()">
                    <span>
                      All Filters
                    </span>
                    <ng-icon name="tablerFilter"></ng-icon>
                  </div>
                  <div class="reset-filters" (click)="resetFilternew()">
                    <span>
                      Reset
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

    <div id="job-listing-content" class="job-listing-content">
      <div id="entity-container" class="job-candidate-container" [class.pointer-events-none]="isFilterOpen">
        <div class="job-candidate-listing-flex-container">



            <div class="entity-listing">
              <!-- V3 left panel header -->
              <div class="jc-v3-lp-header" *ngIf="designVersion === 'v3'">
                <div class="jc-v3-lp-title">
                  <div class="jc-v3-lp-icon">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>
                  </div>
                  Jobs <span class="jc-v3-lp-count">{{totalCountJob}} results found</span>
                </div>
              </div>
              <!-- V2 left panel header (existing) -->
              <div class="entity-listing-header" *ngIf="designVersion !== 'v3'">
                <div class="entity-summary pad-rt-0">
                  <ng-icon name="tablerBriefcase" class="svg-position"></ng-icon>
                  <div class="entity-name">
                    <h6 class="m-0">{{ jobListLabel }}</h6>
                  </div>
                  <div class="entitycount">
                    <span>{{totalCountJob}} results found</span>
                  </div>
                </div>
              </div>

              <!-- NEW SIMPLIFIED SEARCH AND FILTER SECTION -->
              <!-- <div class="search-filter-container-8472">
                <div class="search-input-wrapper-9384">
                  <div class="search-icon-container-2847">
                    <ng-icon name="tablerSearch"></ng-icon>
                  </div>
                  <input
                    #SearchNew
                    placeholder="Search Job Title, Job ID, Skills"
                    type="text"
                    [(ngModel)]="searchContent"
                    [ngModelOptions]="{standalone: true}"
                    (input)="searchfilter(SearchNew.value)"
                    class="search-input-field-5729"
                  />
                </div>
                <div class="filter-actions-container-6192" [ngClass]="{'disabled' : loadCenterSkeleton | async }">
                  <div class="filter-icon-btn-3856" (click)="openFilterSlider()">
                    <div class="filter-icon-wrapper-4721">
                      <svg class="filter-icon-svg-8934" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 7H20M7 12H17M10 17H14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <span class="filter-count-badge-2853" *ngIf="getActiveFilterCount() > 0">
                        {{getActiveFilterCount()}}
                      </span>
                    </div>
                  </div>
                  <div class="reset-btn-1473" (click)="resetFilternew()">
                    Reset
                  </div>
                </div>
              </div> -->

              <div  id="job-body"  class="entity-listing-body" [scrollWindow]="false" infiniteScroll [infiniteScrollDistance]="5"
                [infiniteScrollThrottle]="100" (scrolled)="onScrollDown()" [alwaysCallback]="true">

                <ng-container *ngIf="(loadCenterSkeleton | async)">
                  <app-common-skeleton [countforView]="4" [NameOftheScreen]="'jobcardMediumscreen'"></app-common-skeleton>
                </ng-container>

                <app-jobs #jobsRef [updateJobModule]="jobModule" [loadAPIcall]="(loadSkeleton | async)"  [Obj]="selectedJobData" (updateStatusAndFilters)="onStatusChangeEvent($event)"
                  [responseReceived]="responseReceived"  [jobsFoundStatus]="(loadSkeleton | async) ? '' : jobsFoundStatus" [viewSize]="designVersion === 'v3' ? 'jc-v3-small' : 'small'"  (suggcandidate)="getdatafromjob($event)"
                  (jobReload)="reloadJobData($event)" (jobReloadFromJobComponent)="reloadJobData($event)"(jobListing)="onStatuChange($event)" (selectedJob)="getchildData($event)"
                  [passValues]="(response | async)" style="z-index: -1;"></app-jobs>


                  <div *ngIf="designVersion === 'v3' && stopscrollFlag && (response | async)?.length > 0" class="jc-v3-list-done">
                    <ng-icon name="tablerCircleCheck"></ng-icon>
                    <p>You've reached the bottom of the page</p>
                  </div>
                  <div *ngIf="designVersion !== 'v3' && stopscrollFlag  && (response | async)?.length > 0" class="row caught_up">
                  <div class="col-md-12 mg-bt-9">
                    <ng-icon name="tablerCircleCheck"></ng-icon>
                    <!-- <ng-icon name="tablerCircleCheck"></ng-icon> -->
                  </div>
                  <div class="col-md-12">
                    <p class="biase">You've reached the bottom of the page</p>
                  </div>
                </div>
              </div>
            </div>

          <div class="entity-details" [class.jc-v3-entity-details]="designVersion === 'v3'">

            <app-common-skeleton *ngIf="(loadCenterSkeleton | async)" [NameOftheScreen]="'jobselectedscreen'"></app-common-skeleton>

            <ng-container *ngIf="!(loadCenterSkeleton | async) && (response | async)?.length > 0; else emptyMessage">

              <!-- V3: Persistent detail header (always visible above tabs) -->
              <div class="jc-v3-detail-header" *ngIf="designVersion === 'v3' && selectedJobData?.jobId">
                <!-- Recruiter block template — rendered in Section 1 normally;
                     when there's no org info (FR users) Section 1 is dropped
                     entirely (no empty band) and this re-homes into the
                     title row's right side instead. -->
                <ng-template #dhRecruiterTpl>
                  <div class="jc-v3-dh-recruiter">
                    <img *ngIf="selectedJobData?.user?.photo" class="jc-v3-rec-av"
                      [src]="getAvatarPhotoUrl(selectedJobData?.user?.photo)" alt="avatar"
                      (error)="$any($event.target).style.display='none'">
                    <div *ngIf="!selectedJobData?.user?.photo" class="jc-v3-rec-av"
                      [style.background-color]="getAvatarColor(selectedJobData?.user?.fullname)"
                      [style.color]="getAvatarTextColor(selectedJobData?.user?.fullname)">
                      {{ selectedJobData?.user?.fullname ? selectedJobData.user.fullname.charAt(0) : '' }}{{ selectedJobData?.user?.fullname?.split(' ')[1]?.charAt(0) || '' }}
                    </div>
                    <div class="jc-v3-rec-info">
                      <strong [title]="selectedJobData?.user?.fullname">{{ selectedJobData?.user?.fullname }}</strong>
                      {{ formatUserType(selectedJobData?.user?.userType) }}<ng-container *ngIf="selectedJobData?.jobPostedBehalfOf"> &middot; {{ selectedJobData?.jobPostedBehalfOf }}</ng-container>
                      <ng-container *ngFor="let work of selectedJobData?.user?.workExperience">
                        <span *ngIf="work?.currentOrganization && (work?.city || work?.state)" style="display:block;font-size:11px;color:#6B7280;margin-top:2px;">
                          {{ work?.city }}<span *ngIf="work?.city && work?.state">, </span>{{ work?.state }}
                        </span>
                      </ng-container>
                    </div>
                    <app-connection-template [page]="'jc-v3-job-profile'" [connectionStatus]="selectedJobData?.connectionStatus"
                      [counterpartsDetails]="selectedJobData?.user" [values]="selectedJobData" [module]="'job'"></app-connection-template>
                  </div>
                </ng-template>

                <!-- Section 1: Company + Recruiter — dropped entirely when
                     there's no org info to show (FR users); the recruiter
                     re-homes into the title row below. -->
                <div class="jc-v3-dh-s1" *ngIf="hasJobOrgHeader()">
                  <div class="jc-v3-dh-company">
                    <div class="jc-v3-co-logo">
                      <img *ngIf="getJobBusinessLogo() as logo"
                        [src]="logo" alt="Logo"
                        style="width:100%;height:100%;object-fit:cover;border-radius:10px;">
                      <svg *ngIf="!getJobBusinessLogo()"
                        width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2563EB" stroke-width="2">
                        <rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
                      </svg>
                    </div>
                    <div>
                      <div class="jc-v3-co-name">
                        <ng-container *ngFor="let exp of selectedJobData?.user?.workExperience">
                          <ng-container *ngIf="exp?.currentOrganization || selectedJobData?.jobPostedBehalfOf == exp?.organisationName">
                            {{ exp?.organisationName || selectedJobData?.jobPostedBehalfOf }}
                          </ng-container>
                        </ng-container>
                        <!-- Verified-org star icon — matches V2 baseline
                             (job-profile-detail.component.html:115-116,
                             `<ng-icon name="tablerStar">`). Previously
                             used `&#9733;` which rendered as a plain
                             system-font character, losing the gold
                             cue. -->
                        <ng-icon name="tablerStar" class="jc-v3-star" aria-hidden="true"></ng-icon>
                      </div>
                    </div>
                  </div>
                  <ng-container [ngTemplateOutlet]="dhRecruiterTpl"></ng-container>
                </div>
                <!-- Section 2: Title + Info -->
                <div class="jc-v3-dh-s2">
                  <div class="jc-v3-dh-title-row">
                    <!-- `[title]` tooltip so the full title is accessible
                         on hover whenever it gets clipped by layout
                         (container width, parent overflow, etc.). Kept
                         as template-only change — no CSS max-width so
                         the title doesn't steal space from conditional
                         siblings (SubContracted pill, Apply, toggle,
                         More dropdown). -->
                    <span class="jc-v3-dh-title" [title]="selectedJobData?.jobTitle">{{ selectedJobData?.jobTitle }}</span>
                    <span class="jc-v3-pill jc-v3-pill-green" *ngIf="selectedJobData?.status === 'ACTIVE'">Active</span>
                    <span class="jc-v3-pill jc-v3-pill-amber" *ngIf="selectedJobData?.status === 'ON HOLD'">On Hold</span>
                    <span class="jc-v3-pill jc-v3-pill-amber" *ngIf="selectedJobData?.status === 'DRAFTED'">Draft</span>
                    <span class="jc-v3-pill jc-v3-pill-red" *ngIf="selectedJobData?.status === 'FILLED'">Filled</span>
                    <span class="jc-v3-pill jc-v3-pill-red" *ngIf="selectedJobData?.status === 'CLOSED'">Closed</span>
                    <span class="jc-v3-pill jc-v3-pill-gray" *ngIf="selectedJobData?.status === 'INACTIVE'">Inactive</span>
                    <!-- [style.background-color]="'#ffe5e5'" [style.color]="'#d40000'" -->
                    <span class="jc-v3-c-cand-status" *ngIf="selectedJobData?.status === 'BLOCKED'">Blocked</span>
                    <span class="jc-v3-pill jc-v3-pill-subcontract" *ngIf="subContractedByName"
                      [title]="'SubContracted by ' + subContractedByName">
                      SubContracted by <span class="jc-v3-pill-sc-name">{{ subContractedByName }}</span>
                    </span>
                    <div class="jc-v3-dh-toggle-row">
                      <!-- Apply disabled gate restored to baseline
                           (job-profile-detail.component.html:90-92) — block
                           the click when either the slot is unavailable OR
                           the job isn't ACTIVE. V3 previously only checked
                           status and let Apply fire on unavailable slots. -->
                      <button class="jc-v3-btn jc-v3-btn-primary jc-v3-btn-sm"
                        *ngIf="selectedJobData?.jobPostedBy != userIdStorage && (userType == 'BENCH_RECRUITER' || userType == 'student' || userType == 'JOB_SEEKER' || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION')"
                        [class.disabled]="!selectedJobData?.availability || selectedJobData?.status != 'ACTIVE'"
                        (click)="applySelectedJob()">
                        Apply
                      </button>
                      <!-- Owner job enable/disable toggle — ports V2 behaviour
                           (job-profile-detail.component.html:194-202). Delegates
                           to jobsRef.enableJob() which owns the plan-check + API call.
                           `[class.disabled]="toggleOpen"` restores the V2
                           throttle so rapid re-clicks during an in-flight
                           request don't fire multiple status PUTs.
                           `*ngIf` now only excludes BLOCKED (matching V2's
                           `status != 'BLOCKED'` wrapper gate); terminal
                           states (FILLED/CLOSED/DRAFTED) render the toggle
                           but disable the input so owners see "this job
                           exists but isn't flippable" rather than the
                           toggle just vanishing. -->
                      <label class="jc-v3-dh-toggle-label"
                        [class.disabled]="toggleOpen"
                        *ngIf="selectedJobData?.jobPostedBy === userIdStorage && selectedJobData?.status !== 'BLOCKED'"
                        [title]="selectedJobData?.status === 'FILLED' || selectedJobData?.status === 'CLOSED' || selectedJobData?.status === 'DRAFTED'
                                  ? 'Toggle unavailable in ' + (selectedJobData?.status | titlecase) + ' state'
                                  : (selectedJobData?.status === 'ACTIVE' ? 'Put job on hold' : 'Activate job')">
                        <input type="checkbox"
                          [checked]="selectedJobData?.status === 'ACTIVE'"
                          [disabled]="selectedJobData?.status === 'FILLED' || selectedJobData?.status === 'CLOSED' || selectedJobData?.status === 'DRAFTED'"
                          (change)="toggleSelectedJob($event)">
                        <span class="jc-v3-toggle" [class.on]="selectedJobData?.status === 'ACTIVE'"></span>
                      </label>
                      <button class="jc-v3-btn jc-v3-btn-outline jc-v3-btn-sm"
                        *ngIf="selectedJobData?.jobPostedBy === userIdStorage && selectedJobData?.status !== 'FILLED' && selectedJobData?.status !== 'CLOSED' && selectedJobData?.status !== 'BLOCKED'"
                        (click)="editSelectedJob()">
                        Edit
                      </button>
                      <button class="jc-v3-btn jc-v3-btn-outline jc-v3-btn-sm jc-v3-btn-subcontract"
                        *ngIf="showSubContractButton"
                        (click)="openSubContractModal()">
                        {{ selectedJobData?.subContractStatus === 'PUBLISHED' ? 'Edit Sub-Contract' : 'Sub-Contract Job' }}
                      </button>
                      <div class="jc-v3-dh-more-wrap" dropdown
                        *ngIf="selectedJobData?.jobPostedBy === userIdStorage && selectedJobData?.status !== 'FILLED' && selectedJobData?.status !== 'CLOSED' && selectedJobData?.status !== 'BLOCKED'"
                        [isOpen]="openDetailHeaderDropdown" (isOpenChange)="onDetailHeaderDropdownToggle($event)">
                        <button class="jc-v3-dh-more-btn" dropdownToggle>
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="5" r="1.2"/><circle cx="12" cy="12" r="1.2"/><circle cx="12" cy="19" r="1.2"/></svg>
                          More
                        </button>
                        <ul *dropdownMenu class="dropdown-menu dropdown-menu-right jc-v3-dh-more-dropdown" role="menu">
                          <li role="menuitem"><a class="dropdown-item" (click)="editSelectedJob()"><ng-icon name="tablerEdit" style="margin-right:8px;"></ng-icon>Edit Job</a></li>
                          <li role="menuitem" *ngIf="selectedJobData?.status === 'ACTIVE'"><a class="dropdown-item" (click)="republishSelectedJob()"><ng-icon name="tablerRefresh" style="margin-right:8px;"></ng-icon>Republish</a></li>
                          <li role="menuitem" *ngIf="selectedJobData?.status !== 'INACTIVE' && selectedJobData?.status !== 'DRAFTED' && selectedJobData?.status !== 'ON HOLD' && !selectedJobData?.isFeatured">
                            <a class="dropdown-item" (click)="upgradeSelectedJob()"><ng-icon name="tablerCircleArrowUp" style="margin-right:8px;"></ng-icon>Upgrade Job</a>
                          </li>
                          <li role="menuitem" *ngIf="selectedJobData?.isFeatured && selectedJobData?.status !== 'INACTIVE' && selectedJobData?.status !== 'DRAFTED'">
                            <a class="dropdown-item" (click)="downgradeSelectedJob()"><ng-icon name="tablerCircleArrowDown" style="margin-right:8px;"></ng-icon>Downgrade Job</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <!-- No org info → Section 1 is hidden; the recruiter
                         block re-homes here at the title row's right edge
                         so the header doesn't reserve an empty band. -->
                    <ng-container *ngIf="!hasJobOrgHeader()" [ngTemplateOutlet]="dhRecruiterTpl"></ng-container>
                  </div>
                  <!-- Urgent Hire — ported from V2 detail page pattern
                       (`urgent-hire-container`, job-profile-detail.component.html:180-183).
                       Renders only while the upgrade is still active. -->
                  <div class="jc-v3-urgent-row" *ngIf="getActiveUrgencyDays(selectedJobData) as urgencyDays">
                    <span class="jc-v3-urgent-badge">
                      <ng-icon name="tablerFlame"></ng-icon>
                      Urgent Hire
                    </span>
                    <span class="jc-v3-urgent-countdown">Urgency ends in {{ urgencyDays }} day{{ urgencyDays === 1 ? '' : 's' }}</span>
                  </div>

                  <div class="jc-v3-dh-info-row">
                    <div class="jc-v3-dh-info-item">
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
                      Created {{ selectedJobData?.updatedOn | timezoneDate:'MM/dd/yyyy' }}
                    </div>
                    <div class="jc-v3-dh-info-item" *ngIf="selectedJobData?.jobReferenceId">
                      Job ID <code>{{ selectedJobData?.jobReferenceId }}</code>
                    </div>
                    <div class="jc-v3-dh-info-item" *ngIf="selectedJobData?.city || selectedJobData?.state || selectedJobData?.country">
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
                      {{ gigsumoService.formatLocation(selectedJobData?.city, selectedJobData?.state, selectedJobData?.country) }}
                    </div>
                    <!-- Rate line: `$` prefix + "Employer Estimate:" label +
                         hover tooltip, all restored from baseline
                         job-profile-detail.component.html:141-152. The
                         tooltip is important when the visible text is
                         truncated or when the user wants to confirm the
                         pay type without relying on the short "Hourly"
                         abbreviation. -->
                    <div class="jc-v3-dh-info-item"
                      [title]="(selectedJobData?.targetRateFrom && selectedJobData?.targetRateTo) ?
                               ('Employer Estimate: ' + selectedJobData?.targetRateFrom + ' - ' + selectedJobData?.targetRateTo + ' ' + getJobCurrency(selectedJobData) + ' / ' + getPayType(selectedJobData?.payType)) :
                               'Employer Estimate: Not available'">
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
                      <span class="jc-v3-dh-rate-label">Employer Estimate:</span>
                      <ng-container *ngIf="selectedJobData?.targetRateFrom && selectedJobData?.targetRateTo; else noRateV3Detail">
                        {{ selectedJobData?.targetRateFrom }}–{{ selectedJobData?.targetRateTo }} {{ getJobCurrency(selectedJobData) }} / {{ getPayType(selectedJobData?.payType) }}
                      </ng-container>
                      <ng-template #noRateV3Detail>Not available</ng-template>
                    </div>
                  </div>
                  <div class="jc-v3-dh-info-row" style="margin-bottom:10px;">
                    <!-- Building icon restored from baseline
                         (job-profile-detail.component.html:170-171) so this
                         row matches the neighbouring clientName row
                         visually. -->
                    <div class="jc-v3-dh-info-item" *ngIf="selectedJobData?.showClientType">
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>
                      Position with {{ selectedJobData?.clientType }}
                    </div>
                    <div class="jc-v3-dh-info-item" *ngIf="selectedJobData?.showClientName || selectedJobData?.jobPostedBehalfOf">
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>
                      {{ selectedJobData?.showClientName ? selectedJobData?.clientName : selectedJobData?.jobPostedBehalfOf }}
                    </div>
                    <div class="jc-v3-dh-info-item" *ngIf="selectedJobData?.jobClassification">{{ selectedJobData?.jobClassification }}</div>
                  </div>
                  <div class="jc-v3-dh-tags">
                    <div class="jc-v3-dh-tag" *ngIf="selectedJobData?.workMode">
                      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                      {{ selectedJobData?.workMode }}
                    </div>
                    <!-- Security Clearance — baseline shows this tag in
                         both states so the user can tell "required" vs
                         "not required" at a glance
                         (job-profile-detail.component.html:197-203).
                         V3 previously only rendered the "yes" case, so
                         non-clearance jobs looked silent. Positive →
                         check + `.jc-v3-dh-tag-yes`; negative → X +
                         `.jc-v3-dh-tag-no`. -->
                    <div class="jc-v3-dh-tag jc-v3-dh-tag-yes" *ngIf="selectedJobData?.securityClearance">
                      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                      Security Clearance
                    </div>
                    <div class="jc-v3-dh-tag jc-v3-dh-tag-no" *ngIf="selectedJobData && !selectedJobData?.securityClearance">
                      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                      Security Clearance
                    </div>
                  </div>
                </div>
              </div>

              <div class="entity-details-header">
                <app-job-portfolio [jobData]="selectedJobData" [pageName]="jobDetailsTabName"
                  [jobPortfolio]="jobPortfolioModule" [designVersion]="designVersion" (removeCandidate)="removeCandidate($event)"
                  (resetfilters)="filterReset($event)"></app-job-portfolio>
              </div>
              <div class="entity-details-body" [class.jc-v3-entity-details-body]="designVersion === 'v3'" >
                 <!-- Dynamic component container for JobProfileDetailComponent to break circular dependency -->
                 <ng-container #jobProfileDetailContainer></ng-container>
                <app-job-applicants *ngIf="jobDetailsTabName === 'job-applicants' || jobDetailsTabName === 'candidate-applied'"
                  [jobDetails]="selectedJobData" [pagelist]="jobDetailsTabName" [designVersion]="designVersion"
                  (parentValueChange)="updatetocandidateActivity($event)"> </app-job-applicants>
                <app-talent-pool *ngIf="jobDetailsTabName === 'talent-pool'"
                  [jobDetails]="selectedJobData" [designVersion]="designVersion"
                  [showSuggJobsDataServer]="showSuggJobsDataServer"
                  (parentValueChange)="updatetocandidateActivity($event)">
                </app-talent-pool>
              
                <app-suggested-candidates-ai-list *ngIf="jobDetailsTabName === 'suggested-candidates'"
                  [jobDetails]="selectedJobData" [designVersion]="designVersion">
                </app-suggested-candidates-ai-list>

                <app-jobs-viewed-by *ngIf="jobDetailsTabName === 'jobs-viewed'"
                  [jobDetails]="selectedJobData" [designVersion]="designVersion"></app-jobs-viewed-by>
                <app-jobliked-list *ngIf="jobDetailsTabName === 'jobs-liked'" [jobDetails]="selectedJobData" [designVersion]="designVersion"></app-jobliked-list>
                <app-job-publishto [Event]="event"*ngIf="jobDetailsTabName === 'jobs-activity'" [jobDetails]="selectedJobData"></app-job-publishto>
                <app-candiates-invited *ngIf="jobDetailsTabName === 'candidates-invited'"
                  (parentValueChange)="updatetocandidateActivity($event)"
                  [clickedCandidateIdIntraction]="candidateIdgetfromIntraction"
                  [jobDetails]="selectedJobData" [designVersion]="designVersion"></app-candiates-invited>
                <app-resume-request-sent *ngIf="jobDetailsTabName === 'resume-requests'" [jobDetails]="selectedJobData"
                  [pagelist]="jobDetailsTabName" [designVersion]="designVersion"></app-resume-request-sent>
              </div>
            </ng-container>
          </div>

          <ng-template #emptyMessage>
            <div class="entity-details" [class.jc-v3-entity-details]="designVersion === 'v3'" *ngIf="!loadAPIcall">
              <div class="jc-v3-detail-empty" *ngIf="designVersion === 'v3'">
                <ng-icon name="customEmpty"></ng-icon>
                <p>There's nothing to show here.</p>
              </div>
              <div class="nothing-to-show-svg" *ngIf="designVersion !== 'v3'">
                <ng-icon name="customEmpty"></ng-icon>
                <div>There's nothing to show here.</div>
              </div>
            </div>
          </ng-template>
          <!-- <div class="widget-flex-item"> -->

            <!-- Vertical filter is moved inside candidate-card -->
            <!-- <app-candidate-activity-widget [TabName]="jobDetailsTabName" [CandidateAcvityData]="CandidateAcvityData" [jobDetails]="selectedJobData">
            </app-candidate-activity-widget> -->

            <!-- <div [class.suggestionStick]="suggestionStick" #suggestionSticky>
              <app-common-widget [page]="'GIG_JOB_LIST'"
                *ngIf=" userType!='FREELANCE_RECRUITER' && userType!='MANAGEMENT_TALENT_ACQUISITION'"
                [showsuggJobsData]="showSuggJobsDataServer" [inputData]="'GIG_JOB_LIST'"></app-common-widget>
              <app-common-widget [page]="'GIG_JOB_LIST_BOTH'"
                *ngIf=" userType=='FREELANCE_RECRUITER' || userType=='MANAGEMENT_TALENT_ACQUISITION'"
                [showsuggJobsData]="showSuggJobsDataServer" [inputData]="'GIG_JOB_LIST_BOTH'"></app-common-widget>
            </div>

          </div> -->

        </div>
      </div>
    </div>
  </ng-container>

  <div class="chatPopup">
    <button (click)="chatbottom()" class="btn btn-info btn-circle" type="button"> <ng-icon name="tablerMessage"></ng-icon> Chat
      <span class="badge noti-badge noti-chat-icon" *ngIf="totalmsgcounts>0"> {{totalmsgcounts}}</span></button>
    <app-message-widget style="z-index: -1;" *ngIf="messagemodelflag" (closeMessageModel)="closeMessage($event)"
      [messageDataPass]="messageData"> </app-message-widget>
  </div>
</ng-container>

<ng-container *ngIf="screenName == 'invite-job-listing'">
  <div class="row mr-0">
    <div class="col-sm-8 pad-lt-rt-0">
      <div class="xs-heading-flex-parent">
        <div class="xs-heading-entity">My Jobs</div>
      </div>
      <div #inviteScrollContainer class="xs-body-container" infiniteScroll [infiniteScrollDistance]="4" [infiniteScrollThrottle]="200"
        (scrolled)="onScrollDown()" [scrollWindow]="false" [alwaysCallback]="true">
        <app-jobs [viewSize]="'extra-small'" [responseReceived]="responseReceived" [focus]="focus"
          [jobsFoundStatus]="jobsFoundStatus" (suggcandidate)="getdatafromjob($event)" [loadAPIcall] = "loadAPIcall"
          (jobReload)="reloadJobData($event)" (jobReloadFromJobComponent)="reloadJobData($event)" (selectedJob)="getchildData($event)" [passValues]="(response | async)"
          style="z-index: -1;"></app-jobs>
      </div>
      <div class="xs-footer-container"></div>
    </div>
    <div class="col-sm-4 pad-lt-0 pad-rt-0">
      <div class="hpanel mr-bt-0" data-gs-cards="native">
        <div class="hpanel-heading xs-heading-flex-entity-detail">
          <div>Candidate Details</div>
          <button><span class="modalai-close" aria-hidden="true" (click)="closeCandidateSupplyModal()">&times;</span></button>
        </div>
        <app-job-submit-skillfilter [candidateData]="filterData" [focus]="focus" [feaJ]="feaJ"
          [dataPasstoSkillwidgets]="dataPasstoSkillwidgets" (emitRemoveTag)="removeUserfromTag($event)">
        </app-job-submit-skillfilter>
      </div>
    </div>
  </div>
</ng-container>


